"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectUserLoading = exports.selectUserRole = exports.selectDisplayName = exports.selectIsDeveloper = exports.useSelectUserHasVerifiedContacts = exports.useSelectUser = exports.getMyProfile = exports.uploadUserSliceDeveloperMedia = exports.removeUserSliceDeveloperMedia = exports.removeUserAvatar = exports.setUserAvatar = exports.removeUser = exports.setUser = exports.fetchingUser = exports.userSlice = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var axios_1 = __importDefault(require("axios"));
var GeneralSettings_1 = require("../../constants/GeneralSettings");
var initialState = {
    loading: false,
    data: undefined,
};
exports.userSlice = toolkit_1.createSlice({
    name: 'user',
    initialState: initialState,
    reducers: {
        fetchingUser: function (state) {
            state.loading = true;
        },
        setUser: function (state, action) {
            state.data = action.payload.user;
            state.loading = false;
        },
        setUserAvatar: function (state, action) {
            state.data.avatar = action.payload.avatar;
            state.loading = false;
        },
        removeUserAvatar: function (state) {
            state.data.avatar = '';
        },
        removeUser: function (state) {
            state.data = undefined;
        },
        removeUserSliceDeveloperMedia: function (state, action) {
            state.data.developers[0].developer_media =
                state.data.developers[0].developer_media.filter(function (item) { return item.id !== action.payload.id; });
        },
        uploadUserSliceDeveloperMedia: function (state, action) {
            state.data.developers[0].developer_media = action.payload;
        },
    },
});
exports.fetchingUser = (_a = exports.userSlice.actions, _a.fetchingUser), exports.setUser = _a.setUser, exports.removeUser = _a.removeUser, exports.setUserAvatar = _a.setUserAvatar, exports.removeUserAvatar = _a.removeUserAvatar, exports.removeUserSliceDeveloperMedia = _a.removeUserSliceDeveloperMedia, exports.uploadUserSliceDeveloperMedia = _a.uploadUserSliceDeveloperMedia;
var getMyProfile = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var response, user, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.fetchingUser());
                    return [4 /*yield*/, axios_1.default.get('/api/me')];
                case 1:
                    response = _a.sent();
                    user = response.data;
                    dispatch(exports.setUser({
                        user: user,
                    }));
                    return [2 /*return*/, user];
                case 2:
                    e_1 = _a.sent();
                    throw e_1;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getMyProfile = getMyProfile;
var useSelectUser = function (state) {
    return state.user.data;
};
exports.useSelectUser = useSelectUser;
var useSelectUserHasVerifiedContacts = function (state) {
    var _a;
    var contact = (_a = state.user.data) === null || _a === void 0 ? void 0 : _a.contacts.filter(function (contact) { return contact.verified; });
    return !!(contact === null || contact === void 0 ? void 0 : contact.length);
};
exports.useSelectUserHasVerifiedContacts = useSelectUserHasVerifiedContacts;
var selectIsDeveloper = function (state) {
    if (!state.user.data) {
        return false;
    }
    return state.user.data.roles.includes(GeneralSettings_1.ROLES.DEVELOPER);
};
exports.selectIsDeveloper = selectIsDeveloper;
var selectDisplayName = function (state) {
    var _a, _b, _c;
    return exports.selectIsDeveloper(state)
        ? ((_a = state.user.data) === null || _a === void 0 ? void 0 : _a.developers[0]) && ((_b = state.user.data) === null || _b === void 0 ? void 0 : _b.developers[0].name)
        : (_c = state.user.data) === null || _c === void 0 ? void 0 : _c.username;
};
exports.selectDisplayName = selectDisplayName;
var selectUserRole = function (state) { var _a; return (_a = state.user.data) === null || _a === void 0 ? void 0 : _a.roles[0]; };
exports.selectUserRole = selectUserRole;
var selectUserLoading = function (state) { return state.user.loading; };
exports.selectUserLoading = selectUserLoading;
exports.default = exports.userSlice.reducer;
